export * from './delete-objekt-art.service';
export * from './delete-objekt-art.service.module';